import { select, call, put, takeLatest } from 'redux-saga/effects'
import { defineTypes } from '../helpers'
import ReservationEndpoint from '../persistence/ReservationEndpoint'
import CheckoutEndpoint from '../persistence/CheckoutEndpoint'
import AddTipsEndpoint from '../persistence/AddTipEndpoint'
import { reduxFetch } from '../http/reduxFetch'
import { push } from 'react-router-redux'
import activeJsonApi from '../json-api'
import Alert from 'react-s-alert';

const checkoutTypes = { ...defineTypes('CHECKOUT')  }
const orderTypes = { ...defineTypes('ORDER') }
const payWithCashTypes = { ...defineTypes('PAY_WITH_CASH')  }
const addTipTypes = { ...defineTypes('ADD_TIP')  }
const orderStore = new activeJsonApi('order')

export const initialState = {
  loading: false,
  loaded: false,
}

export const actions = {
  getOrder(id) {
    return { type: orderTypes.REQUEST, id: id}
  },
  checkout(token, id) {
    return { type: checkoutTypes.REQUEST, id: id, token: token }
  },
  payWithCash(id) {
    return { type: payWithCashTypes.REQUEST, id: id }
  },
  addTip(tip_amount, order_id, checkout_type, tip_type) {
    return { type: addTipTypes.REQUEST, tip_type: tip_type, order_id: order_id, tip_amount: tip_amount || null, checkout_type: checkout_type }
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case orderTypes.REQUEST:
      return { ...state, started: true, loading: true }
    case addTipTypes.REQUEST:
      return { ...state, started: true, loading: true, processing: true }
    case addTipTypes.DESTROY:
      return { ...state, loading: false }
    case addTipTypes.FAILURE:
      return { ...state, loading: false, errors: action.errors, processing: false }
    case addTipTypes.SUCCESS:
      return { ...state, loading: false, errors: {}, loaded: true, order: action.order, order_info: action.order_info, processing: false }
    case payWithCashTypes.REQUEST:
      return { ...state, started: true, loading: true, processing: true }
    case payWithCashTypes.DESTROY:
      return { ...state, loading: false }
    case payWithCashTypes.FAILURE:
      return { ...state, loading: false, errors: action.errors, processing: false }
    case payWithCashTypes.SUCCESS:
      return { ...state, loading: false, errors: {}, loaded: true, order: action.order, order_info: action.order_info, processing: false }
    case checkoutTypes.REQUEST:
      return { ...state, started: true, loading: true }
    case checkoutTypes.DESTROY:
      return { ...state, loading: false }
    case checkoutTypes.FAILURE:
      return { ...state, loading: false, errors: action.errors }
    case checkoutTypes.SUCCESS:
      return { ...state, loading: false, loaded: true, order: action.order, order_info: action.order_info }
    case 'VALID_CHECKOUT':
      return { ...state, loading: false, loaded: true }
    default:
      return state
  }
}

export const selectors = {
  order: (store) => {
    return store &&
      store['checkout'] &&
      store['checkout']['order']
  },
  order_info: (store) => {
    return store &&
      store['checkout'] &&
      store['checkout']['order_info']
  },
  customer_id: (store) => {
    return store &&
      store['checkout'] &&
      store['checkout']['order'] &&
      store['checkout']['order']['relationships'] &&
      store['checkout']['order']['relationships']['customer'] &&
      store['checkout']['order']['relationships']['customer']['data'] &&
      store['checkout']['order']['relationships']['customer']['data']['id']
  },
  company_id: (store) => {
    return store &&
      store['checkout'] &&
      store['checkout']['order'] &&
      store['checkout']['order']['relationships'] &&
      store['checkout']['order']['relationships']['company'] &&
      store['checkout']['order']['relationships']['company']['data'] &&
      store['checkout']['order']['relationships']['company']['data']['id']
  },
  customer: (customer_id) => {
    return orderStore.getObject('customers', customer_id)
  },
  company: (store) => {
    let get_company_id = selectors.company_id(store)
    return orderStore.getObject('companies', get_company_id)
  },
  company_website: (store) => {
    let company = selectors.company(store)
    return company
      && company['attributes']
      && company['attributes']['website']
  },
  errors: (store) => {
    return store['checkout'] &&
    store['checkout']['errors']
  },
  loading: (store) => {
    return store['checkout'] &&
      store['checkout']['loading']
  },
  addTipForm: (store) => {
    return store['form'] &&
      store['form']['add_tip_form']
  }
}

export function * checkoutSaga (action) {
  try {
    let form = {}
    form['stripe_token'] = action.token
    form['order_id'] = action.id
    const response = yield call(reduxFetch, CheckoutEndpoint.create(form))
    if ( response['status'] === 'error' ) {
      yield put({type: checkoutTypes.FAILURE, errors: response['errors'] })
    } else {
      yield put({ type: 'VALID_CHECKOUT' })
      yield call(Alert.success, '<div>Successfully Checked out!</div>')
      let company_id = yield select(selectors.company_id)
      let company = yield select(selectors.company)
      yield call(cheersPage)
    }
  } catch (error) {
    yield put({ type: checkoutTypes.FAILURE, errors: error })
  }
}

export function * payWithCashSaga (action) {
  try {
    let form = {}
    form['order_id'] = action.id
    const response = yield call(reduxFetch, CheckoutEndpoint.payWithCash(form))
    if ( response['status'] === 'error' ) {
      yield put({type: payWithCashTypes.FAILURE, errors: response['errors'] })
    } else {
      yield put({ type: payWithCashTypes.SUCCESS })
      yield put({ type: 'RESET_RESERVATION' })
      yield put(push('/cheers', { 'reservationConfirm': true }))
    }
  } catch (error) {
    yield put({ type: payWithCashTypes.FAILURE, error })
  }
}

export function * cheersPage(action) {
  try {
    let company_website = yield select(selectors.company_website)
    yield put(push({ pathname: '/cheers', state: { website: company_website } } ))
  } catch (error) {
    console.log(error)
  }
}

export function * orderSaga(action) {
  try {
    const response = yield call(reduxFetch, ReservationEndpoint.show(action.id))
    orderStore.reset()
    orderStore.updateStore(response)
    yield put({ type: checkoutTypes.SUCCESS, order: response.data, order_info: response.included })
  } catch (error) {
    yield put({ type: checkoutTypes.FAILURE, errors: error })
  }
}

export function * addTipSaga (action) {
  try {
    let form = {}
    let tip_form = yield select(selectors.addTipForm)
		form['tip_amount'] = action.tip_type === 'custom' ? (tip_form.values && tip_form.values['tipAmount'] || '00.00') : action.tip_amount
    form['order_id'] = action.order_id
    form['type'] = action.tip_type
    const response = yield call(reduxFetch, AddTipsEndpoint.create(form))
    if ( response['status'] === 'error' ) {
      yield put({type: addTipTypes.FAILURE, errors: response['errors'] })
    } else {
      if ( action.checkout_type == 'cash' ) {
        yield call(payWithCashSaga, {id: action.order_id})
        yield put({ type: addTipTypes.SUCCESS, errors: {} })
      } else {
        yield put(push({ pathname: `/checkout/${action.order_id}` }))
        yield put({ type: addTipTypes.SUCCESS, errors: {} })
      }
    }
  } catch (error) {
    yield put({ type: addTipTypes.FAILURE, error })
  }
}

export function * rootSaga () {
  yield takeLatest(orderTypes.REQUEST, orderSaga)
  yield takeLatest(checkoutTypes.REQUEST, checkoutSaga)
  yield takeLatest(addTipTypes.REQUEST, addTipSaga)
}



// WEBPACK FOOTER //
// ./src/sagas/checkout.js